import { useEffect } from "react";
import { observer } from "mobx-react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import withHeaderFooter, { IWithHeaderFooterProps } from "@/app/csr-src/hocs/with-header-footer";
import Recommend from "@/common-components-src/js/recommend/index";
import { addCartUtil } from "@/app/csr-src/utils/cartUtils";
import CommonButton from "./components/commonButton";
import styles from "./orderCancelSuccess.module.scss";
import SuccessIcon from "@/app/csr-src/assets/icons/SuccessIcon.svg";
// 埋点
import { sendPv, sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25369";
import { EXPOSURE_RECORD as Recommend_EXPOSURE_RECORD, sendClickTrack as Recommend_sendClickTrack } from "@/tracks/25357";

const OrderCancelSuccess = withHeaderFooter(
  observer(({ JDIHeader }: IWithHeaderFooterProps) => {
    const { t } = useTranslation();
    // const [orderDetails, setOrderDetails] = useState<IOrderDetailRes | null>(null);
    // const [loading, setLoading] = useState<boolean>(true);
    // const [error, setError] = useState<string | null>(null);

    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);

    const styleId = queryParams.get("styleId") || ""; // 获取styleId
    const orderId = queryParams.get("orderId") || "";
    const initCartNumHandler = () => {
      JDIHeader?.current?.initCartNum();
    };

    useEffect(() => {
      sendPv.OrderCenter_CancelSubmit();
      window.scrollTo(0, 0); // 页面跳转时滚动到顶部
    }, []);

    const jumpHomePage = () => {
      sendClickTrack.OrderCancelSubmit_ContinueShopping({ orderId });
      window.location.href = "/";
    };

    const jumpDetailPage = () => {
      sendClickTrack.OrderCancelSubmit_OrderDetail({ orderId });
      navigate(-1);
    };

    const recommendAddCart = (item: { skuId: string }) => {
      addCartUtil([{ skuId: item?.skuId, num: "1" }], initCartNumHandler);
    };

    return (
      <div className={styles.cancel_success_wrap}>
        <Helmet>
          <title>Order Cancelled | Joybuy</title>
          <meta
            name="description"
            content="Your order has been cancelled. Visit Joybuy.com to explore top deals with fast shipping and a delivery guarantee. We hope to serve you again soon!"
          />
        </Helmet>
        <div className={styles.detail_inner_wrap}>
          <div className={styles.cancel_success_content}>
            <div className={styles.title_style}>
              <SuccessIcon className={styles.title_ico} />
              Submission successful
            </div>
            {/* 已经捡货且实付小于等于5英镑落地页提示 */}
            {styleId === "1" && (
              <div className={styles.desc_style}>
                Given your excellent reputation, we have decided to grant a refund without requiring the return of the goods.
              </div>
            )}
            {/* 未捡货，落地页展示申请成功提示文案 */}
            {styleId === "2" && (
              <div className={styles.desc_style}>
                Your cancellation request has been successfully submitted, please visit your order detail page to track the latest status.
              </div>
            )}
            <div className={styles.btn_group}>
              <CommonButton
                variant={"outlined"}
                onClick={jumpHomePage}
                style={{ width: "174px" }}
                exptag={"exp|" + EXPOSURE_RECORD.OrderCancelSubmit_ContinueShoppingExpo}
                data-exptag-config={JSON.stringify({
                  useClick: false,
                  stay_duration: 0.3,
                  repeated: false,
                  area_rate: 0.5,
                })}
                data-exptag-json-param={JSON.stringify({ orderId })}
              >
                Go shopping
              </CommonButton>
              <CommonButton
                variant={"contained"}
                onClick={jumpDetailPage}
                style={{ width: "174px", marginLeft: "12px" }}
                exptag={"exp|" + EXPOSURE_RECORD.OrderCancelSubmit_OrderDetailExpo}
                data-exptag-config={JSON.stringify({
                  useClick: false,
                  stay_duration: 0.3,
                  repeated: false,
                  area_rate: 0.5,
                })}
                data-exptag-json-param={JSON.stringify({ orderId })}
              >
                Order details
              </CommonButton>
            </div>
          </div>
          <Recommend 
            sceneCode="after_sales"
            addCartFn={recommendAddCart}
            trackParams={{
              RecomSku_Expo: Recommend_EXPOSURE_RECORD.OrderCenter_CancelSubmit_RecomSku_Expo,
              RecomSku_Tab_Expo: Recommend_EXPOSURE_RECORD.OrderCenter_CancelSubmit_RecomSku_Tab_Expo,
              RecomSku_Addcart_Expo: Recommend_EXPOSURE_RECORD.OrderCenter_CancelSubmit_RecomSku_Addcart_Expo,
              productClick: Recommend_sendClickTrack.OrderCenter_CancelSubmit_RecomSku,
              tabClick: Recommend_sendClickTrack.OrderCenter_CancelSubmit_RecomSku_Tab,
              addCartClick: Recommend_sendClickTrack.OrderCenter_CancelSubmit_RecomSku_Addcart,
            }} 
          />
        </div>
      </div>
    );
  }),
);

export default OrderCancelSuccess;
